<div class="cart-totals">
  <sd-cart-totals-coupon></sd-cart-totals-coupon>
  <sd-cart-totals-list [cart]="cart()"></sd-cart-totals-list>

  @if (providingBonusForOrder()) {
    <sd-bonus-order-widget [providingBonusForOrder]="providingBonusForOrder()"></sd-bonus-order-widget>
  }

  <sd-cart-totals-order
    sdInViewport
    [cart]="cart()"
    (intersectedEntry)="onIntersectEntry($event)"
  ></sd-cart-totals-order>
</div>

@if (showFloating()) {
  <sd-cart-totals-floating [cart]="cart()"></sd-cart-totals-floating>
}
